export const TXTWCL_Special_characters_are_not_all_ELL = {
  "id": "TXTWCL_Special_characters_are_not_all_ELL",
  "defaultMessage": "Special characters are not allowed."
} as const;